module.exports = __webpack_public_path__ + "img/ecology-action@2x.9480a572.webp";